// src/data/TeamData.js

import LarisaImage from '../image/LarisaWebProfilePic.jpg';
import MichaelaImage from '../image/MichaelaProfile.jpg';
import DanProfileImage from '../image/DanProfile.jpg';

const teamData = [
  {
    name: 'Larisa Mathur',
    title: 'Principal',
    image: LarisaImage,
    description:
      'Larisa is a licensed real estate broker in Florida. She earned a bachelor degree in Industrial Engineering and an MBA from University of New Haven, Connecticut. Larisa’s career began in data science and moved into project management, where she managed M&A system integrations, contract negotiations, and vendor management across multiple industries from retail to aerospace. Larisa heads up a family office and has opened up her partnerships to other real estate sponsors.',
  },
  {
    name: 'Daniel Sirlin',
    title: 'Chief Operating Officer',
    image: DanProfileImage,
    description:
      'Daniel received his law degree from Georgetown University and is licensed to practice in FL, NY, and DC. With over 40 years of legal experience and founder of Panther Real Estate Partners, he’s managed commercial projects with investments up to $35M. He brings deep legal knowledge, strategic deal structuring, and strong industry relationships. Daniel supports all Propertunity legal needs and serves as trustee for the fund.',
  },
  {
    name: 'Michaela Rudis',
    title: 'Head of Sales',
    image: MichaelaImage,
    description:
      'Michaela is a seasoned real estate broker licensed in Massachusetts and California with 25+ years of experience. She specializes in residential, vacation, and commercial properties including medical offices and tech buildings. Her expertise in advertising and buyer psychology drives results. Michaela leads go-to-market strategy and ensures strong positioning across listings.',
  },
];

export default teamData;
